import { useEffect, useState } from "react";

export function useVersionCheck(interval = 300000) {
  const [hasUpdate, setHasUpdate] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(null);

  useEffect(() => {
    let timer;
    async function checkVersion() {
      try {
        if (document.hidden) return; // inactive tab, skip check
        const res = await fetch("/version.json?cache=" + Date.now());
        const data = await res.json();
        if (!currentVersion) setCurrentVersion(data.version);
        else if (currentVersion !== data.version) setHasUpdate(true);
      } catch (e) {
        console.error("Version check failed:", e);
      }
    }

    timer = setInterval(checkVersion, interval);
    return () => clearInterval(timer);
  }, [currentVersion]);

  return hasUpdate;
}
